import RegistrationsThemeProvider from "components/admin/registrations_theme_provider.js"
import { string } from "prop-types"

const AppProvider = ({ component, ...props }) => {
  const Component = window.ReactRailsUJS.getConstructor(component)

  return (
    <RegistrationsThemeProvider>
      <Component {...props} />
    </RegistrationsThemeProvider>
  )
}

AppProvider.propTypes = {
  component: string.isRequired
}

export default AppProvider
